import React from 'react';
import { useSelector } from 'react-redux';
import { selectUserGroupsList } from 'store/userGroups';

import { Select } from 'v1/components/shared';

type UserGroupSelectorProps = {
  size?: 's' | 'm' | 'l';
  value?: string;
  onBlur?: (id: string) => void;
};

const UserGroupSelector = ({ size, value, onBlur }: UserGroupSelectorProps) => {
  const userGroups = useSelector(selectUserGroupsList);
  const convertedSize = size ? size.toUpperCase() : undefined;

  const handleSelect = ({ target }: React.ChangeEvent<HTMLSelectElement>) => {
    onBlur && onBlur(target.value);
  };

  return (
    // @ts-ignore - v1 component
    <Select size={convertedSize} value={value} onChange={handleSelect}>
      {userGroups.map(userGroup => (
        <option key={userGroup.id} value={userGroup.id}>
          {userGroup.name}
        </option>
      ))}
    </Select>
  );
};

export default UserGroupSelector;
